<div class="text-center">
  <div class="spinner-grow" role="status"></div>
  <div class="loading-text pt-3">{{ text }}</div>
</div>
